import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const CommissionPlanFeeTemplateProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `CommissionPlanTemplate/Fees/${props.commissionPlanFeeTemplateId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `CommissionPlanTemplate/${props.commissionPlanTemplateId}/Fees/${props.transactionType}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `CommissionPlanTemplate/Fees/${props.commissionPlanFeeTemplateId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `CommissionPlanTemplate/${props.commissionPlanTemplateId}/Fees/${props.transactionType}`, method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `CommissionPlanTemplate/Fees/${props.commissionPlanFeeTemplateId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { createRecord, newRecord, selectRecord, deleteRecord, listRecords, updateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useCommissionPlanFeeTemplateStore = () => React.useContext(Context);
